$('.tab-module-search').skeletabs({
    autoplay: false,
    panelHeight: 'adaptive',
    slidingAccordion: true,
});